import { request } from '@/api';
import { type MfaType } from './login';

const PREFIX = '/auth/generate';
/**
 * change_password-修改密码 / bind_phone-绑定手机号 / bind_email-绑定邮箱 / cancel_account-账号注销
 */
export type PurposeType = 'change_password' | 'bind_phone' | 'bind_email' | 'cancel_account';
export const PurposeTypeValues = {
  ChangePassword: 'change_password',
  BindPhone: 'bind_phone',
  BindEmail: 'bind_email',
  CancelAccount: 'cancel_account',
} as const;

/**
 * /temp/auth/mfa/verify
 * MFA验证获取临时授权（用于已登录用户执行风险操作）
 * @param mfaType MFA类型
 * @param purpose 操作类型
 * @param code MFA验证码
 * @example
 * verifyMfaRisk(MfaTypeValues.Email, PurposeTypeValues.ChangePassword, '123456');
 */
export const verifyMfaRisk = (mfaType: MfaType, purpose: PurposeType, code: string) => {
  return request.post<{
    authAction: string;
    tempToken: string;
    expireIn: number;
  }>(`${PREFIX}/temp/auth/mfa/verify`, {
    mfaType,
    purpose,
    [mfaType]: code,
  });
};
